import { refreshUserSessionApiCall } from './api';
import { setUser, logout } from '../features/auth/authSlice';

/**
 * Refreshes the user session after role changes
 * @param {Function} dispatch - Redux dispatch function
 * @returns {Object} { success: boolean, user?: object, error?: string }
 */
export const refreshUserSession = async (dispatch) => {
  try {
    const response = await refreshUserSessionApiCall();
    
    if (response.status === 1) {
      // Update Redux store with refreshed user data
      dispatch(setUser({ user: response.data }));
      return { 
        success: true, 
        user: response.data 
      };
    } else {
      return { 
        success: false, 
        error: response.error,
        shouldLogout: true // API call failed, safer to logout
      };
    }
  } catch (error) {
    console.error('Session refresh failed:', error);
    
    return { 
      success: false, 
      error: 'Session refresh failed',
      shouldLogout: true
    };
  }
};

/**
 * Handles session refresh failure with appropriate fallback actions
 * @param {Function} dispatch - Redux dispatch function
 * @param {Function} navigate - React Router navigate function
 * @param {Function} showSnackbar - Snackbar function for user feedback
 * @param {Object} error - Error object from session refresh
 */
export const handleSessionRefreshFailure = (dispatch, navigate, showSnackbar, error) => {
  if (error.shouldLogout) {
    // Force logout for security reasons
    dispatch(logout());
    navigate('/login');
    showSnackbar('Session expired. Please login again.', 'warning');
  } else {
    // Show warning but allow user to continue
    showSnackbar('Session update failed. Please refresh the page or re-login if you experience issues.', 'warning');
  }
};
